export const FETCH_GET_TEMPLATE_REQUEST = "FETCH_GET_TEMPLATE_REQUEST";
export const FETCH_GET_TEMPLATE_SUCCESS = "FETCH_GET_TEMPLATE_SUCCESS";
export const FETCH_GET_TEMPLATE_FAILURE = "FETCH_GET_TEMPLATE_FAILURE";
